import {SmartComponent} from "smart-component-js";

class VideoSectionComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "VideoSectionComponent";
        super(element, parentComponent, params);

        this.$el = $(element);
        this.init();
    }

    init() {
        //Al click su play nascondo il bottone e faccio partire il video
        this.$el.find('.play-btn').click((e) => {
            $(e.target).parents('.video-element').addClass('playing');
            $(e.target).siblings('.video').attr('controls', '').attr('controlsList', 'nodownload')[0].play();
        });

        //Al click sul titolo del video nascondo il video corrente e mostro il nuovo, ed aggiorno lo stato dei titoli
        this.$el.find('.video-title-wrapper [data-index]').click((e) => {
            this.changeTab($(e.currentTarget).data('index'));
        });

        //Le ancore del form puntano alla sola sezione marcata come target (o alla prima, se nessuna e' marcata)
        $(document).on('click', '[data-video-section-click]', (el) => {
            if (!this.isFormAnchorTarget()) {
                return;
            }
            let section = $(el.currentTarget).data('videoSectionClick');
            this.changeTab(section);
            $('html, body').scrollTop(this.$el.offset().top)
        });

        //Aggancio il click preventivo sulle eventuali cta laterali, unico modo per accedere ai tab "secondari"
        this.$el.on('click', '.fake-cta', (e) => {
            let $cta = $(e.currentTarget);
            this.changeTab($cta.data('index'), $cta.data('innerId'));
        });

        //Quando il video finisce mostro ancora il play
        this.$el.find('video').on('ended', (e) => {
            $(e.currentTarget).removeAttr('controls').removeAttr('controlsList');
            this.$el.find('.playing').removeClass('playing');
        });

        //All'avvio clicco il primo elemento.
        this.$el.find('.video-title-wrapper [data-index]:eq(0)').click();
    }

    isFormAnchorTarget() {
        let $targets = $('.video-section-component[data-form-anchor-target="true"]');
        if ($targets.length === 0) {
            $targets = $('.video-section-component');
        }
        return $targets.first().is(this.$el);
    }

    changeTab(index, innerId) {
        if (!innerId) {
            innerId = 0;
        }
        this.$el.find('.video-title-wrapper .active').removeClass('active');
        this.$el.find('.video-title-wrapper [data-index="' + index + '"]').addClass('active');

        this.$el.find('.video-wrapper .active').removeClass('active');
        this.$el.find('.video-wrapper [data-index="' + index + '"][data-inner-id="' + innerId + '"]').addClass('active');

        //Se ci sono video in riproduzione li stoppo
        if (this.$el.find('.playing').length > 0) {
            this.$el.find('.playing video').removeAttr('controls').removeAttr('controlsList');
            this.$el.find('.playing video')[0].pause();
            this.$el.find('.playing video')[0].currentTime = 0;
            this.$el.find('.playing video')[0].load();
            this.$el.find('.playing').removeClass('playing');
        }

        this.updateCopy(index, innerId);
        this.updateSideCta(index, innerId);
    }

    updateCopy(index, innerId) {
        let html = '';
        if (!innerId) {
            html = this.$el.find('.video-wrapper [data-index="' + index + '"] .left-column').html();
        } else {
            html = this.$el.find('.video-wrapper [data-index="' + index + '"][data-inner-id="' + innerId + '"] .left-column').html();
        }

        this.$el.find('.copy').html(html);
    }

    updateSideCta(index, innerId) {
        if (this.$el.find('.video-wrapper [data-index="' + index + '"]').length > 1) {
            let actionLabel = '';
            let html = '';
            this.$el.find('.video-wrapper [data-index="' + index + '"]').each((i, el) => {
                let active = $(el).data('innerId') == 0;
                if (innerId) {
                    active = $(el).data('innerId') == innerId;
                }

                if (active) {
                    active = 'active';
                    if (!!$(el).data('actionLabel')) {
                        actionLabel = $(el).data('actionLabel');
                    }
                }
                html += '<div class="fake-cta ' + active + '" data-index="' + index + '" data-inner-id="' + $(el).data('innerId') + '">' + $(el).data('ctaLabel') + '</div>';
            })
            if (!!actionLabel) {
                html = '<div class="action-label">' + actionLabel + '</div>' + html;
            }
            html = '<div class="cta-wrapper">' + html + '</div>';

            this.$el.find('.copy').append(html);
        }
    }
}

export default VideoSectionComponent;